import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';

import PaymentEvents from 'shared/components/payment-events/payment-events';

import { getChannelIdFromAppSettings } from 'shared/selectors/app-settings';
import getPaymentInfo from 'widget/redux/server/actions/channel/payment';


@connect(state => ({
  channelId: getChannelIdFromAppSettings(state),
}), {
  getPaymentInfo,
})
export default class ReloadChannelPaymentDataOnPayment extends React.Component {
  static propTypes = {
    getPaymentInfo: PropTypes.func,
    channelId: PropTypes.string,
  };

  @autobind
  @debounce
  fetchChannelPaymentData() {
    this.props.getPaymentInfo(this.props.channelId);
  }

  render() {
    return (
      <PaymentEvents onAnyEvent={this.fetchChannelPaymentData} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/reload-channel-payment-data-on-payment.js